// extracted by mini-css-extract-plugin
export default {"Button":"index-module__Button--iKHSe","Box":"index-module__Box--sESXY","NavList":"index-module__NavList--SZn02"};